<template>
  <div class="in-footer target action">
    <div class="in-f-left">
      <dl>
        <h3><img src="@/assets/images/in-f-left2.png"><span>商务合作</span></h3>
        <h4>15995618715/025-52738939</h4>
      </dl>
      <dl>
        <h3><img src="@/assets/images/in-f-left3.png"><span>媒体垂询</span></h3>
        <h4>eeyanjiang@163.com</h4>
      </dl>
    </div>
    <div class="in-f-center">
      <dl>
        <dt><router-link to="/services">服务介绍</router-link></dt>
        <dd>
          <router-link to="/services/products?menu=器件模型提取&type=4">器件模型提取</router-link>
          <router-link to="/services/products?menu=PDK开发&type=5">PDK开发</router-link>
          <router-link to="/services/products?menu=IP设计服务&type=6">IP设计服务</router-link>
          <router-link to="/services/products?menu=IP流片&type=7">IP流片</router-link>
          <router-link to="/services">查看更多</router-link>
          <!-- <router-link to="/services/products?menu=芯片微组装&type=9">芯片微组装</router-link>
          <router-link to="/services/products?menu=货架IP&type=10">货架IP</router-link> -->
        </dd>
      </dl>
      <dl>
        <dt><router-link to="/news">新闻中心</router-link></dt>
        <dd>
          <a @click="goToDetail(news)" class="box" v-for="news in newsList" :key="news.id">{{ news.newNameCn }}</a>
        </dd>
      </dl>
      <dl>
        <dt><router-link to="/about">关于我们</router-link></dt>
        <dd>
          <router-link to="/about">公司概况</router-link>
          <router-link to="/about/list?menu=核心优势&type=2">核心优势</router-link>
          <router-link to="/about/list?menu=合作案例&type=3">合作案例</router-link>
        </dd>
      </dl>
    </div>
    <div class="in-f-right">
      <img src="@/assets/images/1-2501141A2092T.png">
      <img src="@/assets/images/wechat.jpg">

    </div>
    
    <div class="in-f-bottom">
      Copyright © 2002-2024 南京华合半导体科技有限公司 版权所有
      <!-- <a href="http://www.eyoucms.com/plus/powerby.php" target="_blank"> Powered by EyouCms</a> -->
      <router-link to="/">备案号:</router-link>
      <a href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">苏ICP备2025160008号</a>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'IndexFooter',
  data() {
    return {
      newsList: []
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
        getNewsList() {
      this.$request.get('/wx/news/getListByClassIfy', {
        "newType": "1",
        "currentPage": 1,
        "pageSize": 4
      }).then(response => {
        this.newsList = response.data.records
      }).catch(error => {
        console.log(error)
      })
    },
    goToDetail(news) {
      if (news.newNameEn) {
        window.open(news.newNameEn)
        return
      }
      this.$router.push({
        path: '/news/detail',
        query: { id: news.id }
      })
    }
    
  }
}

</script>

<style scoped>
/* c:\Users\14157\Downloads\wechat.jpg */
@media screen and (min-width: 1000px) {
  .in-f-right{
  display: flex; 
  /* flex-direction: column; */
  align-items: center; 
  justify-content: center;
  gap: 2vw;
}

.in-f-right img{
  width: 8vw;
}
}

@media screen and (max-width: 1000px) {
  .in-f-right{
     text-align: center;
  }
  .in-f-right img{
  width: 8vw;
}
}

.box {
  width: 20vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>


